<template>
    <section class="bg-gray-50 dark:bg-gray-900 h-full grid grid-cols-1 md:grid-cols-4 gap-4 py-8 px-8">
        <div class="flex flex-col gap-y-0 w-full rounded-lg py-4 px-4 text-indigo-500 dark:text-purple-300 bg-gray-100 shadow-lg dark:bg-gray-900">
            <span class="material-icons-outlined select-none w-full text-center text-7xl text-purple-500">
                insights
            </span>
            <span class="text-3xl text-center">Métricas pessoais</span>
            <p class="text-gray-200 text-center">Mostrar dados sobre recolhas do pesquisador</p>
            <span class="w-4/5 mt-8 mx-auto">
                <span v-if="!pesquisador" >
                    <span class="material-icons-outlined select-none w-full text-center text-9xl text-gray-600">
                        account_circle
                    </span>
                    <p class="text-gray-600 text-center mt-2">Não selecionado</p>
                </span>
                <span v-else >
                    <div class="w-28 h-28 rounded-full bg-purple-600 mx-auto">
                        <img v-if="pesquisador.avatar" class="rounded-full" draggable="false" :src="pesquisador.avatar" alt="">
                        <span v-else class="h-full w-full flex"><p class="m-auto text-5xl">{{pesquisador.nome[0]}}{{pesquisador.nome.split(' ')[1][0]}}</p></span>
                    </div>
                    <p class="text-gray-200 text-center mt-2">{{pesquisador.nome}}</p>
                </span>
            </span>

            <span class="w-4/5 mt-4 mx-auto">
                <p class="text-gray-200 mb-4">No período</p>
                <DatePicker v-model="anomes" />
            </span>

        </div>
        <div class="gap-y-0 w-full rounded-lg py-6 px-8 bg-gray-100 shadow-lg text-gray-100 dark:bg-gray-800 col-span-3">
            <Metrics v-if="metricas" :metrics="metricas" :pesquisador="pesquisador.nome" @update="updateChart" @changeType="changeChartType"/>
        </div>
    </section>
</template>

<script>
import Spinner from '../Design/Spinner.vue'
import DatePicker from '../Design/Datepicker.vue'
import { METRICAS_PESSOAS } from '../../mixins/api'
import { ref } from '@vue/reactivity'
import Autocomplete from '../Design/Autocomplete.vue'
import Chart from './Chart.vue'
import Metrics from './Metrics.vue'
import { computed, onMounted, watch } from '@vue/runtime-core'
import { useStore } from 'vuex'
export default {
    name: 'DashView',
    components: {
        Spinner,
        Autocomplete,
        DatePicker,
        Chart,
        Metrics
    },
    setup () {
        const numUsuarios = ref(0)
        const numAdms = ref(0)
        const numPesquisadores = ref(0)
        const numLojasAtivas = ref(0)
        const numLojasAdesao = ref(0)

        const months = [
            'Jan',
            'Fev',
            'Mar',
            'Abr',
            'Mai',
            'Jun',
            'Jul',
            'Ago',
            'Set',
            'Out',
            'Nov',
            'Dez'
        ]

        const date = new Date()
        const month = date.getMonth()

        const periodo = months[month] + '/' + date.getFullYear()

        const pesquisador = ref('')
        const store = useStore()
        pesquisador.value = store.getters['auth/user']

        const pesquisadores = ref([])
        const users = ref([])

        const metricas = ref([])

        const anomes = ref(date.getFullYear().toString() + ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)))

        const getMetricasUsuarios = METRICAS_PESSOAS(anomes.value)

        watch(anomes, (n, o) => {
            METRICAS_PESSOAS(n).then((results) => {
                metricas.value = results.data
            })
        })

        onMounted(() => {
            Promise.all([getMetricasUsuarios]).then((results) => {
                metricas.value = results[0].data
            })
        })

        const chartData = ref({
            lojaAtiva: {
                pendente: [0, 0, 0, 0, 0, 0],
                concluida: [0, 0, 0, 0, 0, 0]
            },
            lojaAdesao: {
                pendente: [0, 0, 0, 0, 0, 0, 0, 0, 0],
                concluida: [0, 0, 0, 0, 0, 0, 0, 0, 0]
            }
        })
        const updateChart = (data) => {
            chartData.value = data
        }
        
        const metricsType = ref(true)
        const changeChartType = (t) => {
            
            metricsType.value = t
        }

        return {
            numLojasAtivas,
            numLojasAdesao,
            numPesquisadores,
            numUsuarios,
            numAdms,
            periodo,
            pesquisador,
            pesquisadores,
            anomes,
            users,
            metricas,
            chartData,
            updateChart,
            metricsType,
            changeChartType

        }
    }

}
</script>
